<template>
<div>

   

  <div class="card text-center" >
  <div class="card-body">
    <h5 class="card-title"><strong>IMPORTO PAGAMENTO</strong></h5>
    <div class="row">
    <div class="col-md-6">
      <div class="card-body"></div>

    
    <!-- CASH -->
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-prepend">  
        <div style="background-color:#339900;color:white;width:150px" class="input-group-text"><strong>CONTANTE</strong>  </div>        
          <div class="input-group-text">€</div>        
        </div>
        <input :disabled="CouponIdentification" step="0.01"  v-focus type="number" :style="{fontSize: '30px'}" class="form-control" id="inputCash" placeholder="Contante" v-model="cash">
      </div>
    </div>

    <!-- ELEC -->
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-prepend">          
          <div style="background-color:#FF6600;color:black;width:150px" class="input-group-text"><strong>ELETTRONICO</strong></div>  
          <span class="input-group-text"> €</span>       
        
        </div>
        <input :disabled="CouponIdentification" step="0.01" type="number" :style="{fontSize: '30px'}" class="form-control" id="inputElettronico" placeholder="Elettronico" v-model = "electronic">       
      </div>
    </div>

  <!-- COUP -->
    <div class="form-group">

      <div v-if="!CouponIdentification" class="input-group">

        <div class="input-group-prepend">  
          <div style="background-color:navy;color:white;width:150px" class="input-group-text"><strong>COUPON</strong></div>  
          <span class="input-group-text"> €</span>              
        </div>
          <input step="0.01" type="number" :style="{fontSize: '30px'}" class="form-control" id="inputCoupon" placeholder="Coupon" v-model = "coupon">        
          <button v-if="1==1"  @click="CouponIdentification = !CouponIdentification" class="btn btn-primary float-left"
            data-toggle="modal" title="Identificazione coupon"  >
            <i  class="fas fa-search-dollar" aria-hidden="true"></i>
          </button>      
      </div>
      </div>
       
      <div v-if="CouponIdentification" >
        
        <CouponIdentificationList @close="setCouponIdentification" ></CouponIdentificationList>
        
      </div>

    <OtherPayment v-bind:disabled="CouponIdentification" @update="setOtherPayment"></OtherPayment>  
    
    </div>
    </div>
    
  </div>
  <div v-if="1==0" class="custom-control custom-switch text-right mr-3 mb-3">
        <input  type="checkbox" class="custom-control-input" id="printReceipt" name="printReceipt" v-model="printReceipt" >
        <label class="custom-control-label" for="printReceipt">
        <strong>STAMPA SCONTRINO</strong>
        </label>
    </div>


  </div>


<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

<button :disabled="bt_spinner || CouponIdentification" @click="checkOut()"  class="btn btn-primary float-right mt-2 mr-2">
  <i  class="fas fa-check-circle mr-2" aria-hidden="true"></i>
  ESEGUI PAGAMENTO
  <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
</button>


</div>

</template>

<script>

//import axios                     from 'axios'
import api                       from '@/api'
import { mapGetters }            from 'vuex';
import alertBox                  from '@/components/common/AlertBox.vue'
import OtherPayment              from "@/components/frontOffice/checkOut/OtherPayment.vue"
import CouponIdentificationList  from "@/components/frontOffice/coupon/CouponIdentificationList.vue"
import fmt                       from '@/components/mixins/fmt'
import selfCash                  from '@/components/mixins/SelfCash.js'




export default {

mixins     : [fmt,selfCash],
props : ['customerId'], 

components: { alertBox, OtherPayment, CouponIdentificationList, CouponIdentificationList },
  data () {
    return {
           
      deskId       : 1,  
      cash         : 0,
      electronic   : 0,
      coupon       : 0,           
      payment      : [],
      printReceipt : 0,
      //alert        : false,
      msg          : {
        title      : '',
        body       : '',
        type       : 0
      },
           
      bt_spinner  : false,
      
      otherPayment    : {
        total : 0.00,
        type : ''
      },
      CouponIdentification : false,
      barcode : '',
      coupons : []
      

    }
  },
  directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  computed: 
  {
   ...mapGetters(['storeId','company']) ,   
      
     
  },
  async mounted() 
  {
    
    let deskId = JSON.parse(localStorage.getItem("deskId"))
    if(deskId)
    {    
      this.deskId = Number(deskId)
    }
    //await this.storeSelfCashApi()

  },  
  created()
  {

    this.cash         = this.cash.toFixed(2)      
    this.electronic   = this.electronic.toFixed(2) 
    this.coupon       = this.coupon.toFixed(2)   
    this.otherPayment.total = this.otherPayment.total.toFixed(2)      

   
    
  },
  methods: 

  {
   
     
    setCouponIdentification(couponList)
    {
      this.CouponIdentification = !this.CouponIdentification
      
      

      couponList.forEach(item =>{
        this.coupon = Number(this.coupon) +  Number(item.total)
      })
      this.coupons = couponList
      
      
    },
  
    setOtherPayment(total,type)
    {

      

      this.otherPayment.total = total      
      this.otherPayment.type = type
      
      /* FORSE LO DEVO TOGLIERE */
      if(total)
      {
        this.otherPayment.total = total
      

      }
      
    },

    
    
    checkFormat()
    {
    
      if(!this.cash)
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Formato importo CONTANTE non corretto.'
        this.msg.type  = 1
        return false
      }
            
      if(!this.electronic)
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Formato importo ELETTRONICO non corretto.'
        this.msg.type  = 1
        return false
      }

      if(!this.coupon)
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Formato importo COUPON non corretto.'
        this.msg.type  = 1
        return false
      }
      if(!this.otherPayment.total)
      {
      
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Formato importo ' + this.otherPayment.type + ' non corretto. Inserire un valore uguale o maggiore di zero.'
        this.msg.type  = 1
        return false
      }
      
    },

    async checkOut()
    {
      this.msg.title = ''
      if(this.checkFormat() == false)
      {
        return
      }
      if(this.cash == 0 && this.electronic == 0 && this.coupon == 0 && this.otherPayment.total == 0)
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Importo pagamento non valido'
        this.msg.type  = 1
          return
      }
      if(this.cash > 100000 || this.electronic > 100000 || this.coupon > 100000 || this.otherPayment.total > 10000) 
      {
       
        this.msg.title = ' - ATTENZIONE - '
        this.msg.body  = 'Importo pagamento non valido'
        this.msg.type  = 1
          return
      }    
    
     
     
      this.msg.title = ''
      this.bt_spinner = true
      
      const data     = {}
            
      data.header  = {}
      data.payment = {}

      data.header.companyId     = this.company.Id
      data.header.storeId       = this.storeId
      data.header.deskId        = this.deskId
      data.header.total         = 0
      data.header.discount      = 0
      
      data.header.customerId    = this.customerId
      data.header.printTicket   = this.printReceipt == true ? 1 : 0
     
      data.payment              = this.dataPayment()
      data.coupons              = this.coupons
    
      const sp    = {'sp':'spCreateCustomerPayment'}
      

      const json  = Object.assign(data, sp);
      await api.post(json).then(res => {
      if(res.status==200)
        {
          
          if(Number(this.cash) > 0)
          {
            
            const cash = Number(this.cash)  
            const total = this.fmt1(cash).replace(',','')                        
            //this.sendTotalToSelfCash(total)
            
                        
          }
          this.$emit('close','OK')         
        }
        else if(res.status==500)
        {
          
          this.msg.title = 'ATTENZIONE '
          this.msg.body = res.data
          this.msg.type = 1
        } 
        else
        {
          this.msg.title = 'ATTENZIONE '
          this.msg.body = res
          this.msg.type = 1
        } 
        }).catch(err => 
        {
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err.message
          this.msg.type = 1
      
        }).finally(() => {
          this.bt_spinner = false
        });

      

       
      
    },
    dataPayment()
    {
      const arr = []
      
      if(Number(this.cash) != 0)
      {
        arr.push({'typeId':'CASH','amount' : Number(this.cash).toFixed(2)  })
      }
      
      if(Number(this.electronic) !=0 )
      {
        arr.push({'typeId':'ELEC','amount' : Number(this.electronic).toFixed(2)})
      }

      if(Number(this.coupon)!=0)
      {
        arr.push({'typeId':'COUP','amount' : Number(this.coupon).toFixed(2)})
      }

      if(Number(this.otherPayment.total) != 0)
      {
        
        arr.push({'typeId':this.otherPayment.type,'amount': Number(this.otherPayment.total).toFixed(2)})
      }
     
      return arr
    },

    
 
    

  }
}
</script>
<style scoped>
.custom-control-label
{
  cursor : pointer;
  
}
h4,p {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

</style>